import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { Coordinate } from 'shared/@types';

export type DeviceLocation = Coordinate & { accuracy: number; timestamp: number };

const useLocationStore = create(
  combine(
    {
      location: null as DeviceLocation | null,
      approximateLocation: null as Coordinate | null,
      approximateLocationReady: false,
      errorMessage: null as string | null,
      place: null as string | null,
      loading: false,
      revision: 0,
    },
    (set) => ({
      setLocation: (location: DeviceLocation) => {
        set((state) => ({
          location,
          place:
            state.location?.latitude === location.latitude &&
            state.location.longitude === location.longitude
              ? state.place
              : null,
        }));
      },
      setApproximateLocation: (approximateLocation: Coordinate | null) => {
        set({ approximateLocation, approximateLocationReady: true });
      },
      setErrorMessage: (errorMessage: string | null) => {
        set({ errorMessage, loading: false });
      },
      setPlace: (place: string) => {
        set({ place });
      },
      setLoading: (loading: boolean) => {
        set({ loading });
      },
      reset: () => {
        set((state) => ({
          location: null,
          approximateLocation: null,
          approximateLocationReady: false,
          errorMessage: null,
          place: null,
          loading: false,
          revision: state.revision + 1,
        }));
      },
    }),
  ),
);

export default useLocationStore;
